import React, { useEffect, useRef } from "react";
import logo from "../assets/ops-banner.png";
import JsBarcode from "jsbarcode";

const DocketPreview = ({ formData }) => {
  if (!formData) return null;

  const payment = formData?.paymentType || {};
  const payMode = formData?.paymentMode || {};
  const docs = formData?.documentsReceived || {};
  const vas = formData?.valueAddedService || {};
  const mode = formData?.modeOfPayment || {};
  const charges = formData?.charges || {};

  const Barcode = ({ value }) => {
    const ref = useRef(null);

    useEffect(() => {
      if (value) {
        JsBarcode(ref.current, value, {
          format: "CODE128",
          width: 1.5, // 🔥 sharper print
          height: 40,
          displayValue: true,
          fontSize: 10,
        });
      }
    }, [value]);

    return <svg ref={ref}></svg>;
  };

  return (
    <div className="w-full bg-white text-xs  font-sans">
      {/* HEADER */}
      <div className="flex items-center justify-between border-b border-black pb-1">
        <img src={logo} alt="Logo" className="h-12 object-contain" />
        <Barcode value={formData?.docketNumber || "N/A"} />
      </div>
      {/* TOP INFO */}
      <div className="grid grid-cols-4 border-b border-l border-r border-black">
        {[
          ["Origin", formData?.origin],
          ["Destination", formData?.destination],
          ["Mode", formData?.transportMode],
          [
            "Date / Time",
            `${formData?.bookingDate} | ${formData?.bookingTime}`,
          ],
        ].map(([label, val]) => (
          <div
            key={label}
            className="px-2 py-1 border-r border-black text-xs last:border-r-0"
          >
            <b>{label}:</b> {val || "N/A"}
          </div>
        ))}
      </div>
      {/* FROM / TO */}
      <div className="grid grid-cols-2 border-b border-l border-r border-black">
        {[
          ["FROM", formData?.from],
          ["TO", formData?.to],
        ].map(([title, data]) => (
          <div key={title} className="border-r border-black last:border-r-0">
            <div className="text-center border-b border-black font-semibold py-1">
              {title}
            </div>
            <div className="p-2 text-xs">
              <p>
                <b>Name:</b> {data?.name}
              </p>
              <p>
                <b>Address:</b> {data?.address}
              </p>
              <p>
                <b>Phone:</b> {data?.phoneNo}
              </p>
              {data?.gst && (
                <p>
                  <b>GST:</b> {data?.gst}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* PACKAGE */}
      <table className="w-full border border-t-0 border-l-0 border-r-0 border-black">
        <thead>
          <tr>
            {[
              "Invoice No",
              "Invoice Date",
              "Invoice Value",
              "E-Way Bill No",
              "Boxes",
              "Dimension",
              "Type",
            ].map((h) => (
              <th
                key={h}
                className="px-2 py-1 text-xs  border-r font-semibold border border-black border-t-0 "
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {[
              formData?.invoiceNo,
              formData?.invoiceDate,
              formData?.invoiceValue,
              formData?.eWayBillNo,
              formData?.numberOfBoxes,
              formData?.boxDimension,
              formData?.packageType,
            ].map((val, i) => (
              <td
                key={i}
                className="px-2 border-r border-l border-black py-1 text-xs text-center"
              >
                {val || "-"}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      {/*
       */}
      <div className="grid grid-cols-[60%_40%] border-l border-r border-black">
        <div className="border-r border-black p-3 space-y-3">
          <div className="grid grid-cols-2 gap-2 text-xs">
            <p>
              <b>Said to Contain:</b>
              <br />
              {formData?.saidToContain || "N/A"}
            </p>
            <p>
              <b>Risk Coverage:</b>
              <br />
              {formData?.riskCoverage || "N/A"}
            </p>
            <p>
              <b>Policy & Validity:</b>
              <br />
              {formData?.policyAndValidity || "N/A"}
            </p>
            <p>
              <b>No. of Documents:</b>
              <br />
              {formData?.numberOfDocuments || "N/A"}
            </p>
          </div>

          <div className="border-t border-black"></div>

          <div>
            <p className="font-semibold pb-1">Payment Mode</p>
            <div className="flex gap-4 text-xs">
              {["cash", "dd", "cheque"].map((key) => (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={payMode?.[key] || false}
                    readOnly
                  />{" "}
                  {key.toUpperCase()}
                </label>
              ))}
            </div>
            <p className="text-xs mt-1">COD: {formData?.codAmount || 0}</p>
            <p className="text-xs">Words: {formData?.amountInWords || "-"}</p>
          </div>

          <div className="border-t border-black"></div>

          <div>
            <p className="font-semibold pb-1">Documents Received</p>
            <div className="flex gap-4 text-xs">
              <label>
                <input
                  type="checkbox"
                  checked={docs?.invoice || false}
                  readOnly
                />{" "}
                Invoice
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={docs?.eWaybill || false}
                  readOnly
                />{" "}
                E-Way
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={docs?.others || false}
                  readOnly
                />{" "}
                Others
              </label>
            </div>
          </div>

          <div className="border-t border-black"></div>

          <div>
            <p className="font-semibold pb-1">Value Added Services</p>
            <div className="flex gap-4 text-xs">
              <label>
                <input
                  type="checkbox"
                  checked={vas?.appointmentDelivery || false}
                  readOnly
                />{" "}
                Appointment
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={vas?.specialDelivery || false}
                  readOnly
                />{" "}
                Special
              </label>
            </div>
          </div>

          <div className="border-t border-black"></div>

          <div className="text-[10px] italic">
            I/We have carefully checked and verified the contents of this
            consignment note and hereby agree to the terms and conditions set
            out on the reverse of the consignor copy and declare the contents on
            the waybill are true and correct. The To-pay (POD) Freight amount
            has my/our consent and will be paid by the consignee or any taxes at
            the time of delivery.
          </div>

          <div className="font-semibold pt-2">Consignor's Signature</div>
        </div>

        <div className="p-3 space-y-2">
          <table className="w-full border border-black">
            <tbody>
              <tr className="border border-black">
                <td className="px-2 py-1 text-xs">Actual Wt</td>
                <td className="text-center text-xs">
                  {formData?.actualWeight || 0}
                </td>
              </tr>
              <tr>
                <td className="px-2 py-1 text-xs">Charged Wt</td>
                <td className="text-center text-xs">
                  {formData?.chargedWeight || 0}
                </td>
              </tr>
            </tbody>
          </table>

          <div>
            <p className="font-semibold pb-1">Payment Type</p>
            <div className="flex gap-4 text-xs">
              {["credit", "paid", "fod"].map((key) => (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={payment?.[key] || false}
                    readOnly
                  />{" "}
                  {key.toUpperCase()}
                </label>
              ))}
            </div>
          </div>

          <table className="w-full border border-black">
            <tbody>
              {[
                ["Base Freight", charges?.baseFreight],
                ["Processing", charges?.processingCharge],
                ["Fuel", charges?.fuelSurcharge],
                ["ROV", charges?.rovCharge],
                ["FOD", charges?.fodCharge],
                ["Handling", charges?.handlingCharge],
                ["COD/DOD", charges?.codDodCharge],
                ["Special Delivery", charges?.specialDelivery],
                ["Other", charges?.otherCharges],
                ["Sub Total", charges?.subTotal],
                ["GST", charges?.gst],
                ["Grand Total", charges?.grandTotal],
              ].map(([label, val]) => (
                <tr key={label} className="border-b border-black">
                  <td className="px-2 py-1 text-xs">{label}</td>
                  <td className="text-center text-xs">{val || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div>
            <p className="font-semibold pb-1">Mode of Payment</p>
            <div className="flex gap-4 text-xs">
              <label>
                <input type="checkbox" checked={mode?.cash || false} readOnly />{" "}
                Cash
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={mode?.chequeDd || false}
                  readOnly
                />{" "}
                Cheque/DD
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={mode?.neftRtgs || false}
                  readOnly
                />{" "}
                NEFT/RTGS
              </label>
            </div>
          </div>

          <div className="text-xs">
            <p>Cheque / NEFT No: {formData?.chequeNeftNo || "-"}</p>
            <p>Bank: {formData?.bank || "-"}</p>
            <p>Words: {formData?.amountInWordsPayment || "-"}</p>
          </div>
        </div>
      </div>
      <div className="flex justify-between px-3 pb-20 border-t border-black py-2 text-xs">
        <div>
          <b>Consignee Stamp</b>
        </div>
        <div>
          <b>Name & Signature</b>
        </div>
        <div>
          <b>Date</b>
        </div>
      </div>
    </div>
  );
};

export default DocketPreview;
